export default __webpack_public_path__ + "static/20-sitzer-2-a28702fa956109fea348957b654732bb.jpg";